var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChangeCity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A1AAC7;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.9,4c-1,0-2.1,0.4-2.9,1.2L5.4,20.8L5.2,21l-0.1,0.3L4,26.8l-0.3,1.5L5.2,28l5.5-1.1l0.3-0.1l0.2-0.2 L26.8,11c1.6-1.6,1.6-4.2,0-5.8C26,4.4,25,4,23.9,4z M23.9,5.9c0.5,0,1,0.2,1.5,0.7c1,1,1,2,0,3l-0.7,0.7l-3-3l0.7-0.7 C22.9,6.1,23.4,5.9,23.9,5.9z M20.3,8.7l3,3L11.2,23.8c-0.7-1.3-1.7-2.3-3-3L20.3,8.7z M6.9,22.4c1.2,0.5,2.1,1.4,2.6,2.6l-3.3,0.7 L6.9,22.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeCity);
export default __webpack_public_path__ + "static/media/changeCity.08e4df325f2d8107937a31619c1e014e.svg";
export { ForwardRef as ReactComponent };